import React from 'react';
import { useLocation } from '@reach/router';
import { Redux, Slices } from 'spwa-ui-library';
import { useIntl } from 'react-intl';
import Button from '@material-ui/core/Button';
import { AiFillInfoCircle } from '@react-icons/all-files/ai/AiFillInfoCircle';
import { decimalChecker, capitalizeFirstLetter } from 'spwa-ui-library/esm/utils/helper';
import { dpodIconClickGA } from 'spwa-ui-library/esm/utils/helperGA';
import css from './index.module.scss';
import ClassNames from 'classnames';
import InfoPopper from './InfoPopper';

const { useSelector } = Redux;
const { selectCurrentCountry } = Slices.profileSlice;
const { selectDefaultAddress } = Slices.addressSlice;
const { selectCountryValidations } = Slices.configSlice;

export default function CartValues({ amountObj, currency }) {
  const intl = useIntl();
  const location = useLocation();
  const country = useSelector(selectCurrentCountry);
  const [toolTipState, setToolTipState] = React.useState(null);
  const [toolTipType, setToolTipType] = React.useState(null);
  const defaultAddress = useSelector(selectDefaultAddress);
  const countryValidations = useSelector((state) => selectCountryValidations(state, country));

  React.useEffect(() => {
    handleToolTipClose();
  }, [amountObj]);

  const handleToolTipClose = () => {
    setToolTipState(null);
    setToolTipType(null);    
  }

  const handleToolTip = (event, type) => {
    setToolTipState(event.currentTarget);
    setToolTipType(type);
    dpodIconClickGA(
      amountObj,
      defaultAddress,
      location.pathname,
      countryValidations?.deliveryFeeBreakup
    );
  };

  const langLabel = capitalizeFirstLetter(intl.locale);

  if (!amountObj) return;

  const subTotal = amountObj?.find((obj) => obj?.type === 'SUB_TOTAL');

  return (
    <div className={css.amount}>
      {amountObj?.map((cartAmount, idx) => {
        const checkforDpod =
          cartAmount.type === 'SHIPPING' && countryValidations?.enableDynamicDeliveryTooltip;

        const checkForSmallOrder = cartAmount.type === 'SMALL_ORDER_FEE';

        return (
          <React.Fragment>
            <div
              key={cartAmount.type}
              className={ClassNames(css.amountItem, {
                [css.discountItem]: cartAmount.type === 'DISCOUNT',
              })}
            >
              <div className={css.amountTitle}>
                {countryValidations.constants.cartAmount.find((obj) => obj.name === cartAmount.type)
                  .value === 'Total' ? (
                  <div className={css.totalWrap}>
                    <span className={css.customTotalStyle}>
                      {
                        countryValidations.constants.cartAmount.find(
                          (obj) => obj.name === cartAmount.type
                        ).value
                      }
                    </span>
                  </div>
                ) : (
                  countryValidations.constants.cartAmount.find(
                    (obj) => obj.name === cartAmount.type
                  ).value
                )}

                {checkforDpod || checkForSmallOrder ? (
                  <>
                    <Button
                      aria-describedby={cartAmount.type}
                      className={css.buttonTolltip}
                      onClick={(e) => handleToolTip(e, cartAmount.type)}
                    >
                      <AiFillInfoCircle />
                    </Button>
                  </>
                ) : (
                  ''
                )}
              </div>
              <div className={css.amountPrice}>
                {cartAmount.type === 'SHIPPING' &&
                cartAmount.strikeoutamount > cartAmount?.amount ? (
                  <span>
                    {decimalChecker(cartAmount.strikeoutamount)} {currency}
                  </span>
                ) : (
                  ''
                )}
                {cartAmount.type === 'DISCOUNT' ? '-' : ''} {decimalChecker(cartAmount?.amount)}{' '}
                {currency}
              </div>
            </div>
            {toolTipType ? (
              <InfoPopper subTotal={subTotal.amount} currency={currency} cartAmount={amountObj.find((obj) => obj.type === toolTipType)} anchor={toolTipState} langLabel={langLabel} handleClose={handleToolTipClose} />
            ) : null}
          </React.Fragment>
        );
      })}
    </div>
  );
}
